import searchLogo from "../assets/images/searchLogo.svg";
import ContractLinkComponent from "../components/ContractLink";
import TickerHyperLinkComponent from "../components/TickerHyperLinkComponent";
import { rateFormatter } from "./commonFunctions";
import { dtcStatusColors, lnetStatusColors } from "./constants";

function is_number(char: any) {
  {
    return !isNaN(parseInt(char));
  }
}
var myValueFormatter = (p: any) => {
  let is_n = is_number(p.value);
  if (is_n) {
    return formatNumber.format(p.value);
  }
};
var myValueFormatter_d = (p: any) => {
  let is_n = is_number(p.value);

  if (is_n) {
    return formatNumber_d.format(Math.ceil(p.value));
  }
};
const formatNumber = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
});
const formatNumber_d = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

var myValueFormatter_quantity = (p: any) => {
  let is_n = is_number(p.value);
  if (is_n) {
    return formatNumber_q.format(p.value);
  }
};

const formatNumber_q = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
});

export const ColumnDtcSummaryDefs = [
  {
    headerName: "Id",
    field: "id",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    hide:true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 75,
    maxWidth: 75,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
  },
  {
    headerName: "Acc Id",
    field: "account_id",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 75,
    maxWidth: 75,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
  },
  {
    headerName: "Cusip",
    field: "cusip",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 85,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
  },
  {
    headerName: "Ticker",
    field: "ticker",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 75,
    width: 65,
    maxWidth: 180,
    suppressSizeToFit: false,
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    cellRenderer: TickerHyperLinkComponent
  },
  {
    headerName: "Box Qty",
    field: "box_qty",
    floatingFilter: false,
    type: "rightAligned",
    filter: "agNumberColumnFilter",
    editable: false,
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
        justifyContent: "flex-end",
      };
    },
    // cellStyle: function (params: any) {
    //   if (
    //     params.node.data?.boxQtyCurrentValue ===
    //     BoxComparisonValueEnum.Increased
    //   ) {
    //     return {
    //       backgroundColor: "#05f719",
    //     };
    //   } else if (
    //     params.node.data?.boxQtyCurrentValue ===
    //     BoxComparisonValueEnum.Decreased
    //   ) {
    //     return {
    //       backgroundColor: "#fc5549",
    //     };
    //   } else {
    //     return {
    //       display: "flex",
    //       alignItems: "center",
    //       borderRight: "0.5px solid #DFDFDF",
    //       justifyContent: "flex-end",
    //     };
    //   }
    // },
    cellRenderer: "agAnimateShowChangeCellRenderer",
    minWidth: 100,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Value",
    field: "col_value",
    floatingFilter: false,
    type: "rightAligned",
    filter: "agNumberColumnFilter",
    editable: false,
    valueFormatter: myValueFormatter,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
        justifyContent: "flex-end",
      };
    },
    cellRenderer: "agAnimateShowChangeCellRenderer",
    minWidth: 100,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Seg Qty",
    field: "seg_qty",
    floatingFilter: false,
    type: "rightAligned",
    filter: "agNumberColumnFilter",
    editable: false,
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
        justifyContent: "flex-end",
      };
    },
    // cellStyle: function (params: any) {
    //   if (
    //     params.node.data?.segQtyCurrentValue ===
    //     BoxComparisonValueEnum.Increased
    //   ) {
    //     return {
    //       backgroundColor: "#05f719",
    //     };
    //   } else if (
    //     params.node.data?.segQtyCurrentValue ===
    //     BoxComparisonValueEnum.Decreased
    //   ) {
    //     return {
    //       backgroundColor: "#fc5549",
    //     };
    //   } else {
    //     return {
    //       display: "flex",
    //       alignItems: "center",
    //       borderRight: "0.5px solid #DFDFDF",
    //       justifyContent: "flex-end",
    //     };
    //   }
    // },
    cellRenderer: "agAnimateShowChangeCellRenderer",
    minWidth: 100,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },

  {
    headerName: "Last Updated Date",
    field: "updatedDateStr",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 160,
    maxWidth: 180,
    suppressSizeToFit: false,
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Created Date",
    field: "createdDate",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 160,
    maxWidth: 180,
    suppressSizeToFit: false,
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Created By",
    field: "created_by",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 160,
    maxWidth: 180,
    hide: true,
    suppressSizeToFit: false,
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Updated By",
    field: "updated_by",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 160,
    maxWidth: 180,
    hide: true,
    suppressSizeToFit: false,
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
];

export const ColumnDtcInDefs = [
  {
    headerName: "Acc Id",
    field: "account_id",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 75,
    maxWidth: 75,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Type",
    field: "msg_type",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 80,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Ref Message Id",
    field: "ref_msgid",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 70,
    maxWidth: 70,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "B/L",
    field: "borrow_loan",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };

    },
    minWidth: 70,
    maxWidth: 200,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },

  {
    headerName: "Cpty",
    field: "cpty",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 77,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Ticker",
    field: "ticker",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 75,
    width: 65,
    maxWidth: 180,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    cellRenderer: TickerHyperLinkComponent
  },
  {
    headerName: "Cusip",
    field: "cusip",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 85,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },


  {
    headerName: "Qty",
    field: "quantity",
    type: "rightAligned",
    floatingFilter: false,
    filter: "agNumberColumnFilter",
    editable: false,
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
        justifyContent: "flex-end",
      };
    },
    minWidth: 100,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Value",
    field: "money",
    type: "rightAligned",
    floatingFilter: false,
    filter: "agNumberColumnFilter",
    editable: false,
    valueFormatter: myValueFormatter,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
        justifyContent: "flex-end",
      };
    },
    minWidth: 120,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Reason Code",
    field: "reason_code",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 120,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  
  {
    headerName: "Code",
    field: "activity_code",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 70,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Activity",
    field: "activity_descrition",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 100,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Action Desc",
    field: "action_desc",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 100,
    maxWidth: 250,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Lnet Status",
    field: "dtc_loanet_status",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params?.data?.dtc_loanet_status?.toLowerCase() === "match") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: lnetStatusColors.match
        };
      }
      if (params?.data?.dtc_loanet_status?.toLowerCase() === "non-match") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: lnetStatusColors.nonMatch
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
        };
      }
    },
    minWidth: 110,
    maxWidth: 200,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },

  {
    headerName: "Lnet Contract",
    field: "loanet_contract",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 120,
    maxWidth: 200,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
 
  {
    headerName: "Pending Reason Desc",
    field: "rsn_for_pend_ind_desc",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 150,
    maxWidth: 400,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Last Updated Date",
    field: "updatedDateStr",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 160,
    maxWidth: 180,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Created Date",
    field: "createdDate",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 160,
    maxWidth: 180,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Status",
    field: "processing_status",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 100,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },

  {
    headerName: "Reason Desc",
    field: "reason_desc",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 120,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Comments",
    field: "comment",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 180,
    maxWidth: 400,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },


  {
    headerName: "DTC Status Ind Desc",
    field: "dtc_status_ind_desc",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 150,
    maxWidth: 400,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Action",
    field: "action_code",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 70,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Pending Reason",
    field: "rsn_for_pend_ind",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 130,
    maxWidth: 400,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Status Ind",
    field: "dtc_status_ind",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    minWidth: 90,
    maxWidth: 400,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Created By",
    field: "created_by",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 160,
    maxWidth: 180,
    hide: true,
    suppressSizeToFit: false,
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Updated By",
    field: "updated_by",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 160,
    maxWidth: 180,
    hide: true,
    suppressSizeToFit: false,
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
];

export const ColumnDtcOutDefs = [
  {
    headerName: "Acc Id",
    field: "account_id",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 75,
    maxWidth: 75,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Type",
    field: "loanet_txn_description",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 100,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Contract Id",
    field: "contract_id_new",
    floatingFilter: false,
    editable: false,
    filter: "agTextColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "0.5px solid #E1E1E1",
    },
    cellRenderer: ContractLinkComponent,
    minWidth: 100,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Activity Id",
    field: "activity_id",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 90,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "B/L",
    field: "bl",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 60,
    maxWidth: 60,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cpty",
    field: "cptyId",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 80,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Ticker",
    field: "ticker",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 75,
    width: 65,
    maxWidth: 180,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    cellRenderer: TickerHyperLinkComponent
  },
  {
    headerName: "Cusip",
    field: "sec_id",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 85,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },


  {
    headerName: "Qty",
    field: "quantity",
    type: "rightAligned",
    floatingFilter: false,
    filter: "agNumberColumnFilter",
    editable: false,
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
      justifyContent: "flex-end",
    },
    minWidth: 100,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Rate",
    field: "rate",
    type: "rightAligned",
    floatingFilter: false,
    filter: "agNumberColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
      justifyContent: "flex-end",
    },
    minWidth: 70,
    maxWidth: 70,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    valueFormatter: rateFormatter
  },
  {
    headerName: "Value",
    field: "colvalue",
    type: "rightAligned",
    floatingFilter: false,
    filter: "agNumberColumnFilter",
    editable: false,
    valueFormatter: myValueFormatter,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
      justifyContent: "flex-end",
    },
    minWidth: 100,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Version",
    field: "version",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 75,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },

  {
    headerName: "Term Date",
    field: "term_date",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 95,
    maxWidth: 110,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Settle Date",
    field: "smnt_date",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 95,
    maxWidth: 110,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Lnet Status",
    field: "status",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 95,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Dtc Status",
    field: "dtc_status",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params?.data?.dtc_status?.toLowerCase() === "settled") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: dtcStatusColors.settled
        };
      }
      if (params?.data?.dtc_status?.toLowerCase() === "pended") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.pended
        };
      } if (params?.data?.dtc_status?.toLowerCase() === "rad") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.RAD
        };
      } if (params?.data?.dtc_status?.toLowerCase() === "approved") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.approved
        };
      } if (params?.data?.dtc_status?.toLowerCase() === "reversed") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.reversed
        };
      } if (params?.data?.dtc_status?.toLowerCase() === "dropped") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.dropped
        };
      } if (params?.data?.dtc_status?.toLowerCase() === "non-ccf") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.nonCcf
        };
      } if (params?.data?.dtc_status?.toLowerCase() === "canceled") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.canceled
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
        };
      }
    },
    minWidth: 100,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Created Date",
    field: "createdDate",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 160,
    maxWidth: 180,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Last Updated Date",
    field: "updatedDateStr",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 160,
    maxWidth: 180,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Created By",
    field: "created_by",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 160,
    maxWidth: 180,
    hide: true,
    suppressSizeToFit: false,
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Updated By",
    field: "updated_by",
    floatingFilter: false,
    filter: "agTextColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 160,
    maxWidth: 180,
    hide: true,
    suppressSizeToFit: false,
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
];
